import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-form-label.tsx
var LazyFormLabel = lazy(() => import("./form-label-Lh6O7mOP.js").then((n) => n.n).then((module) => ({ default: module.FormLabel })));
function FormLabel({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "form-label" }),
		children: /* @__PURE__ */ jsx(LazyFormLabel, { ...props })
	});
}
function FormLabelContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "form-label" }),
		children: /* @__PURE__ */ jsx(LazyFormLabel, { ...props })
	});
}
var useFormLabelContent = () => {
	return useMemo(() => ({ formLabel: { component: FormLabelContent } }), []);
};
//#endregion
export { FormLabel, useFormLabelContent };
